module.exports = __webpack_public_path__ + "img/ods.dd57c336.png";